var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_2989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 10.1703C1.66602 8.26323 1.66602 7.30972 2.09868 6.51928C2.53135 5.72883 3.3218 5.23825 4.90271 4.2571L6.56938 3.22272C8.2405 2.18557 9.07607 1.66699 9.99935 1.66699C10.9226 1.66699 11.7582 2.18557 13.4293 3.22272L15.096 4.2571C16.6769 5.23825 17.4673 5.72883 17.9 6.51928C18.3327 7.30972 18.3327 8.26323 18.3327 10.1703V11.4378C18.3327 14.6885 18.3327 16.3139 17.3564 17.3238C16.3801 18.3337 14.8087 18.3337 11.666 18.3337H8.33268C5.18999 18.3337 3.61864 18.3337 2.64233 17.3238C1.66602 16.3139 1.66602 14.6885 1.66602 11.4378V10.1703Z",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15H7.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_2989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.b4fa20906af78e38a645fa95529fa635.svg";
export { ForwardRef as ReactComponent };